
import { useEffect, useState } from 'react';

import { addMonths, format } from 'date-fns';

// language
import { injectIntl, IntlShape } from 'react-intl';

// redux
import { useSelector } from 'react-redux';

// @mui material components
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";

// icons
import { reservationIconWhite } from 'assets/icons'
import EditIcon from '@mui/icons-material/Edit';

// types
import { ReservationData, } from 'types/typesRedux';

interface Props {
  intl: IntlShape,
  isEdit: boolean,
  setIsEdit: ( bool: boolean ) => void,
  handleEditReservation: (key: string, bool: boolean, data: string) => void,
  handleAddFine: (bool: boolean) => void,
}

function ReservationInfo( { intl, isEdit, setIsEdit, handleEditReservation,handleAddFine } :Props ): JSX.Element {

  const reservation = useSelector( (state: ReservationData) => state.reservationDetail.reservation )

  // const [isEdit, setIsEdit] = useState<boolean>(false);

  const handleStatusColor = () => {
    if ( reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusPending' }) ) {
      return '#F5A524';
    } else if ( reservation.status === intl.formatMessage({ id: 'tableReservations.approved' }) ) {
      return '#309B0A';
    } else if ( reservation.status === intl.formatMessage({ id: 'tableReservations.rejected' }) ) {
      return '#DD2626';
    } else if ( 
      reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusCancelledByCustomer' }) ||
      reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusCancelledByAdmin' })
    ) {
      return '#DD2626';
    } else if ( reservation.status === intl.formatMessage({ id: 'tableReservations.completed' }) ) {
      return '#309B0A';
    } else if ( reservation.status === intl.formatMessage({ id: 'tableReservations.ready' }) ) {
      return '#006FEE';
    }
  }
    
  return (
    <>
      <MDBox        
        sx= {{ width: "25rem", display: "flex",
          flexDirection: "column",
          padding: "0.8rem 1.5rem", backgroundColor: "#ffffff",
          borderRadius: "0.75rem",
        }}
      >

        <MDBox 
          sx= {{ 
            width: "100%", display: "flex", flexDirection: "row", 
            justifyContent: "flex-start",
          }}
        >
          <MDBox className= "badge"
            sx={{ 
              // backgroundColor: "#17C063",
              p: 1, mt: -4, ml: 0,
              borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
            }}
              display="grid"
              justifyContent="center"
              alignItems="center"
              bgColor="#17C063"
              color="white"
              width="4.5rem"
              height="4.5rem"
              shadow="md"
              borderRadius="lg"
              variant="gradient"  
              fontSize= "2.2rem"        
          >
            {reservationIconWhite}
          </MDBox>

          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
              flex: 1, justifyContent: "space-between",
            }}
          >
            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                alignItems: "flex-start", marginLeft: "1rem",
                justifyContent: "center",
              }}
            >
              <MDTypography
                sx={{
                  fontSize: "1.2rem", fontWeight: "700",
                }}
              >
                {intl.formatMessage({id:'reservationDetail.title'})}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "400",
                  color: handleStatusColor(), marginTop: "-0.2rem",
                }}
              >
                {reservation.status}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                alignItems: "flex-end", marginLeft: "1rem",
                justifyContent: "center",
              }}
            >
              <MDTypography
                sx={{
                  fontSize: "0.625rem", fontWeight: "400",
                }}
              >
                {reservation.createdAt}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.625rem", fontWeight: "400",
                  color: "#807E7B", marginTop: "0.2rem",
                }}
              >
                {reservation.id}
              </MDTypography>
            </MDBox>

          </MDBox>

        </MDBox>

        <MDBox
          sx={{
            display: 'flex', flexDirection: 'column',
            alignItems: "flex-start",
          }}
        >
          <MDTypography
            sx={{
              fontSize: "0.75rem", fontWeight: "700",
            }}
          >
            {reservation.userName}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.625rem", fontWeight: "400",
              color: "#807E7B",
            }}
          >
            {reservation.userEmail}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.625rem", fontWeight: "400",
              color: "#807E7B",
            }}
          >
            {reservation.userPhone}
          </MDTypography>
        </MDBox>

        <Divider
          orientation="horizontal"
          flexItem
          sx={{ 
            width: '100%', height: '1px', marginTop: "0.3rem", 
            marginBottom: "0rem", background: 'black',
          }}
        />            

        <MDBox
          sx={{
            display: "flex", flexDirection: "row",
            justifyContent: "space-between",  marginTop: "0.3rem",
          }}
        >
          <MDBox
            sx={{
              display: "flex", flexDirection: "column",
            }}
          >
            <MDTypography 
              sx={{
                fontSize: "0.625rem", fontWeight: "400",
                color: "#807E7B"
              }}
            >
              {intl.formatMessage({id:'reservationDetail.place'})}
            </MDTypography>
            <MDTypography
              sx={{
                fontSize: "0.75rem", fontWeight: "700",
                // color: handleColorStatus(),
              }}
            >
              {reservation.place}
            </MDTypography>
          </MDBox> 

          <MDBox
            sx={{
              display: "flex", flexDirection: "row",
            }}
          >
            <MDBox
              sx={{
                display: "flex", flexDirection: "column",
                paddingRight: "3rem",
              }}
            >
              <MDTypography 
                sx={{
                  fontSize: "0.625rem", fontWeight: "400",
                  color: "#807E7B"
                }}
              >
                {intl.formatMessage({id:'reservationDetail.dateTime'})}
              </MDTypography>
              <MDTypography
                sx={{
                  fontSize: "0.75rem", fontWeight: "700",
                  // color: handleColorStatus(),
                }}
              >
                {reservation.startAt}
              </MDTypography>
            </MDBox>
            { (reservation.status === intl.formatMessage({id: 'reservationDetail.StatusPending'})
              || reservation.status === intl.formatMessage({id: 'tableReservations.approved'})) && (
            <Tooltip title={ intl.formatMessage({id: 'button.change'}) }>
              <IconButton 
                aria-label="Edit" 
                size="small"
                onClick={ () => setIsEdit( true ) }
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            )}

          </MDBox>

        </MDBox>  

        <Divider
          orientation="horizontal"
          flexItem
          sx={{ 
            width: '100%', height: '1px', marginTop: "0.3rem", 
            marginBottom: "0rem", background: 'black',
          }}
        />

        <MDBox
          sx={{
            display: "flex", flexDirection: "column",
          }}
        >
          <MDTypography
            sx={{
              fontSize: "0.625rem", fontWeight: "400",
              color: "#807E7B"
            }}
          >
            {intl.formatMessage({id:'reservationDetail.requiredBoats'})}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.75rem", fontWeight: "700",
              // color: handleColorStatus(),
            }}
          >
            {reservation.boatsCount}
          </MDTypography>
        </MDBox>

        {(reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusPending' }) ||
            reservation.status === intl.formatMessage({ id: 'tableReservations.approved' }) ||
            reservation.status === intl.formatMessage({ id: 'tableReservations.ready' }) ||
            (reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusCancelledByCustomer' }) && !reservation.fineAmount) )
            && (
          <>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ 
                width: '100%', height: '1px', marginTop: "0.3rem", 
                marginBottom: "0rem", background: 'black',
              }}
            />
      
            <MDBox
              sx={{
                display: "flex", flexDirection: "row",
                justifyContent: "space-between", marginTop: "0.7rem",
                marginBottom: "0.5rem"
              }}
            >          

              { (reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusPending' }) ||
                reservation.status === intl.formatMessage({ id: 'tableReservations.approved' }) ||
                reservation.status === intl.formatMessage({ id: 'tableReservations.ready' }))
                && (
                  <MDButton
                    variant="contained"
                    color="error"
                    onClick={() => handleEditReservation( 'status', true, 'rejected' )}
                  >
                    { intl.formatMessage({ id: 'button.rejected' }) }
                  </MDButton>
                )
              }

              { (reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusCancelledByCustomer' })
                && !reservation.fineAmount) && 
                (
                  <MDButton
                    variant="contained"
                    color="error"
                    onClick={() => handleAddFine( true )}
                  >
                    { intl.formatMessage({ id: 'button.addFines' }) }
                  </MDButton>
                )
              }

              { reservation.status === intl.formatMessage({ id: 'reservationDetail.StatusPending' })
                ? (
                  <MDButton 
                    variant="contained"
                    color="darkGreen" 
                    onClick={() => handleEditReservation( 'status', true, 'approved' )}
                  >
                    { intl.formatMessage({ id: 'button.approved' }) }                  
                  </MDButton>
                )
                : reservation.status === intl.formatMessage({ id: 'tableReservations.approved'})
                  ? (
                    <MDBox
                      sx={{
                        display: "flex", flexDirection: "row",
                        justifyContent: "flex-end", width: "100%"
                      }}
                    >
                      <MDButton 
                        variant="contained"
                        color="blue" 
                        onClick={() => handleEditReservation( 'status', true, 'ready' )}
                      >
                        { intl.formatMessage({ id: 'button.ready' }) }                  
                      </MDButton>
                    </MDBox>
                  )
                : reservation.status === intl.formatMessage({ id: 'tableReservations.approved'})
                  ? (
                    <MDBox
                      sx={{
                        display: "flex", flexDirection: "row",
                        justifyContent: "flex-end", width: "100%"
                      }}
                    >
                      <MDButton 
                        variant="contained"
                        color="blue" 
                        onClick={() => handleEditReservation( 'status', true, 'ready' )}
                      >
                        { intl.formatMessage({ id: 'button.ready' }) }                  
                      </MDButton>
                    </MDBox>
                  )
                : null
              }      
            </MDBox>
          </>
        )}

      </MDBox>
    </>
  );
}

export default injectIntl(ReservationInfo);
